var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inventory-items" },
    [
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _vm._v(" Товарно-материальные ценности "),
              _c("Button", {
                attrs: {
                  responsive: "",
                  label: "Выдать ТМЦ",
                  icon: {
                    icon: "plus",
                    color: "blue",
                  },
                },
                on: { click: _vm.issueItem },
              }),
            ],
            1
          ),
          _c("ItemsTable", {
            ref: "itemsTable",
            attrs: { "worker-id": _vm.workerId },
            on: { change: _vm.update },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "title" }, [_vm._v("История изменений")]),
          _c("HistoryTable", {
            ref: "historyTable",
            attrs: { "worker-id": _vm.workerId },
          }),
        ],
        1
      ),
      _c("IssueItemModal", {
        ref: "issueInventoryItemModal",
        attrs: { "worker-id": _vm.workerId },
        on: { submit: _vm.update },
      }),
      _c("TopButton", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }